export interface Testimonial {
  name: string;
  username: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Marek Kowalski',
    username: '@marek_analityk',
    content: 'USFansSpreadsheet to absolutnie najlepsze źródło informacji o arkuszach kalkulacyjnych. Dzięki ich przewodnikom zaoszczędziłem dziesiątki godzin pracy. Polecam każdemu, kto poważnie myśli o analizie danych.',
  },
  {
    name: 'Anna Nowak',
    username: '@anna_dane',
    content: 'Szukałam kompletnego przewodnika po arkuszach i trafiłam na USFansSpreadsheet. Porównania narzędzi są niesamowicie szczegółowe i pomocne. Wreszcie znalazłam rozwiązanie idealne dla mojej firmy.',
  },
  {
    name: 'Piotr Wiśniewski',
    username: '@piotr_biznes',
    content: 'Jako przedsiębiorca potrzebowałem szybkiego dostępu do najlepszych narzędzi. USFansSpreadsheet dostarcza wszystkiego w jednym miejscu — od poradników po rankingi. To mój codzienny punkt odniesienia.',
  },
  {
    name: 'Katarzyna Zielińska',
    username: '@kasia_arkusze',
    content: 'Przewodniki USFansSpreadsheet są napisane w sposób jasny i przystępny. Nawet skomplikowane tematy stają się zrozumiałe. Do tego świetne porównania i analizy bezpieczeństwa. Gorąco polecam!',
  },
  {
    name: 'Tomasz Lewandowski',
    username: '@tomek_freelancer',
    content: 'Od miesięcy korzystam z rekomendacji USFansSpreadsheet i ani razu się nie zawiodłem. Ich rankingi są aktualne i rzetelne, a artykuły pokazują rzeczywiste zastosowania narzędzi. Złoty standard w branży.',
  },
  {
    name: 'Magdalena Wójcik',
    username: '@magda_it',
    content: 'USFansSpreadsheet pomogło mi wybrać odpowiednie narzędzie do zarządzania danymi w moim zespole. Porównanie z Excelem i Google Sheets było kluczowe dla naszej decyzji. Dziękuję za profesjonalne podejście!',
  },
];